var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Add a Location","size":"lg"},on:{"on-hide":_vm.resetFormData}},[_c('locations-form',{key:_vm.formKey,attrs:{"client_ids":_vm.client_ids},on:{"on-submit":_vm.createLocation,"on-save":_vm.redirectToLocation,"on-cancel":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }